import { types } from '../types/types';

const initialState = {
    downloading: false,
    progress: 0,
    showModal: false,
    total: 0,
    canceled: false
};

export const downloadReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.downloadStart:
            return {
                ...state,
                downloading: true,
                progress: 0,
                showModal: true,
                canceled: false
            };

        case types.downloadProgress:
            return {
                ...state,
                progress: action.payload
            };

        case types.downloadFinish:
            return {
                ...state,
                downloading: false,
                progress: 100
            };

        case types.downloadCloseModal:
            return {
                ...state,
                showModal: false
            };

        case types.downloadSetTotal:
            return {
                ...state,
                total: action.payload
            };

        case types.downloadCancel:
            return {
                ...state,
                downloading: false,
                canceled: true,
                showModal: false
            };

        default:
            return state;
    }
};

export default downloadReducer;